import { create } from 'zustand';

type LoadingStore = {
  loading: boolean;
  message: string;
  showLoading: (message: string) => void;
  hideLoading: () => void;
};

export const useLoadingStore = create<LoadingStore>(set => ({
  loading: false,
  message: '',
  showLoading: (message: string) => set({ loading: true, message }),
  hideLoading: () => set({ loading: false, message: '' }),
}));
